<template>
    <div class="garage-container">
        <div class="garage-fancy monospaced">
            <p>~ $ cd garage</p>
            <br />
            <p>~/garage $ cat README.md</p>
            <p>
            - Here in my garage, just got this new <del>Lamborghini</del>project here. 
            (It’s) fun to drive up here in the <del>Hollywood</del>Torrey Pines hills.
            </p>
            <br />
            <p>~/garage $ ./draw-a-frog</p>
            <p class="asciiart">
     @..@        
    (\--/)      
   (.>__<.)               
   ^^^  ^^^ 
            </p>
            <p>~/garage $ <span class="blinking-cursor">_</span></p>
        </div>
        <div class="project-list-container">
            <project-list></project-list>
        </div>
    </div>
</template>

<script>
    import ProjectList from './ProjectList.vue'

    export default {
        name: 'Garage',
        components: {
            ProjectList
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.asciiart{
    white-space: pre;
}

.garage-container {
    display: flex;
    margin-bottom: 5em;
}

.garage-fancy {
    flex: 1;
    color: white;
    max-width: calc(400px + 5em);
    min-width: 300px;
    max-height: 800px;
    padding: 12px 25px;
    margin-right: 5em;
    background-color: #222;
    transform: rotate(10deg);
    position: relative;
    top: 3em;
}

@media (max-width: 800px) {
    .garage-fancy{
        display: none;
    }
}

.project-list-container {
    flex: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// Garage.vue?762b9474